/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import { IUserForgotPasswordPageDispatchProps, IUserForgotPasswordPageOwnProps, IUserForgotPasswordPageStateProps, UserForgotPasswordPage } from "source/components/user/public/UserForgotPasswordPage";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IUserForgotPasswordPageOwnProps): IUserForgotPasswordPageStateProps {
    return {
    };
}

export function mapDispatchToProps(dispatch: any): IUserForgotPasswordPageDispatchProps {
    return {
    };
}

export default connect<IUserForgotPasswordPageStateProps, IUserForgotPasswordPageDispatchProps, IUserForgotPasswordPageOwnProps>(mapStateToProps, mapDispatchToProps)(UserForgotPasswordPage);